export const SITE = {
  name: "Dal Conte",
  tagline: "Pizzeria di Campagna",
  address: "Frazione Villagana 25, 25030 Villachiara (BS)",
  addressShort: "Villachiara (BS)",
  phone: "3318906495",
  phoneHref: "tel:+393318906495",
  phoneDisplay: "331 890 6495",
  email: "info@pizzeriadalconte.it",
  emailHref: "mailto:info@pizzeriadalconte.it",
  hoursDays: "Mercoledì — Domenica",
  hoursTime: "19:00 — 22:30",
  closed: "Lunedì — Martedì · chiuso",
  closedShort: "Lun — Mar · chiuso",
  reserveUrl: "https://app.resmio.com/dal-conte-pizzeria-di-campagna/widget?source=Instagram",
  instagram: "https://www.instagram.com/",
  openingDate: "venerdì 31 luglio 2026",
  openingShort: "31.07.2026",
  concept: "Pizza · Birra · Smash Burger",
  mapEmbed:
    "https://www.google.com/maps?q=DAL+CONTE+Pizzeria+di+Campagna,+Frazione+Villagana+25,+25030+Villachiara+BS&output=embed",
  mapLink:
    "https://www.google.com/maps/place/DAL+CONTE+-+Pizzeria+di+Campagna/@45.3394463,9.9236265,17z",
};
